// 设置browserHeaderTitle
import {
  getStore
} from '@/utils/store'
export const SET_BROWSERHEADERTITLE = 'SET_BROWSERHEADERTITLE'
const app = {
  state: {
    browserHeaderTitle: getStore({
      name: 'browserHeaderTitle'
    }) || '智慧食堂'
  },
  mutations: {
    [SET_BROWSERHEADERTITLE]: (state, action) => {
      state.browserHeaderTitle = action.browserHeaderTitle
    }
  }

}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js